import { useState } from "react";
import { api } from "@/lib/api";
import { Star, MessageSquareHeart, Loader2, Check } from "lucide-react";

const CATEGORIES = [
  { id: "generale", label: "Impressione generale" },
  { id: "chatbot", label: "Labor AI" },
  { id: "prenotazione", label: "Prenotazione" },
  { id: "ux", label: "Facilità d'uso" },
];

export default function FeedbackWidget() {
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [text, setText] = useState("");
  const [category, setCategory] = useState("generale");
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async () => {
    if (!rating) return;
    setSubmitting(true);
    try {
      await api.post("/feedback", { rating, text, category });
      setSent(true);
    } catch (e) {
      alert("Errore, riprova più tardi.");
    } finally { setSubmitting(false); }
  };

  if (sent) {
    return (
      <div className="paper-card p-6 bg-green-50 border-l-4 border-labor-italianGreen" data-testid="feedback-sent">
        <div className="flex items-center gap-3">
          <Check className="w-8 h-8 text-labor-italianGreen" />
          <div>
            <div className="font-display text-xl text-labor-italianGreen">Grazie per il tuo feedback!</div>
            <p className="text-sm text-labor-muted mt-1">Il tuo parere ci aiuta a migliorare Labor AI. 💙</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="paper-card p-6" data-testid="feedback-widget">
      <div className="flex items-center gap-2 mb-4">
        <MessageSquareHeart className="w-5 h-5 text-labor-terracotta" />
        <h2 className="font-display text-2xl">Lascia un feedback</h2>
      </div>
      <p className="text-sm text-labor-muted mb-4">Ci aiuti a migliorare Labor AI? Ci vogliono meno di 30 secondi. 🙏</p>

      <div className="mb-4">
        <div className="text-xs uppercase tracking-widest text-labor-muted mb-2">Su cosa vuoi dirci?</div>
        <div className="flex gap-2 flex-wrap">
          {CATEGORIES.map((c) => (
            <button key={c.id} data-testid={`fb-cat-${c.id}`} onClick={() => setCategory(c.id)}
              className={`px-3 py-1.5 text-sm ${category === c.id ? "bg-labor-olive text-white" : "border border-labor-border"}`}>
              {c.label}
            </button>
          ))}
        </div>
      </div>

      <div className="mb-4">
        <div className="text-xs uppercase tracking-widest text-labor-muted mb-2">Il tuo voto</div>
        <div className="flex gap-1" data-testid="fb-stars">
          {[1, 2, 3, 4, 5].map((n) => (
            <button key={n} data-testid={`fb-star-${n}`}
              onMouseEnter={() => setHover(n)} onMouseLeave={() => setHover(0)} onClick={() => setRating(n)}
              className="p-1">
              <Star className={`w-8 h-8 transition-colors ${(hover || rating) >= n ? "fill-labor-warning text-labor-warning" : "text-labor-border"}`} />
            </button>
          ))}
        </div>
      </div>

      <div className="mb-4">
        <textarea data-testid="fb-text" rows={4} value={text} onChange={(e) => setText(e.target.value)}
          placeholder="Cosa ti è piaciuto o cosa manca? (facoltativo)"
          className="w-full px-3 py-2.5 border border-labor-border focus:outline-none focus:ring-2 focus:ring-labor-terracotta" />
      </div>

      <button data-testid="fb-submit" disabled={!rating || submitting} onClick={submit}
        className="olive-btn px-6 py-3 font-semibold disabled:opacity-40 flex items-center gap-2">
        {submitting ? <Loader2 className="w-4 h-4 animate-spin" /> : <MessageSquareHeart className="w-4 h-4" />}
        Invia feedback
      </button>
    </div>
  );
}
